import React, {useCallback} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Button from '../common/Button'
import {useSelector} from 'react-redux'
import {selectGameUrl, selectShareDisabled} from '../../selectors/createGame'
import {
  SHARE_STATUS_HIDE,
  SHARE_WORD_DONE,
  SHARE_WORD_START,
} from '../../reducers/createGame'
import {performMobileShare} from '../../helpers/share'
import {useDelayedDispatch, useSimpleDispatch} from '../../helpers/dispatch'
import {mergeRight, objOf} from 'ramda'

export default function createShareButton() {
  if (navigator.share) {
    return ShareButton
  } else {
    return CopyButton
  }
}

function ShareButton() {
  const disabled = useSelector(selectShareDisabled)
  const url = useSelector(selectGameUrl)
  const dispatchStart = useSimpleDispatch(SHARE_WORD_START)
  const dispatchDone = useSimpleDispatch(SHARE_WORD_DONE)

  const onClick = useCallback(() => {
    dispatchStart()
    performMobileShare(dispatchDone, url)
  }, [url, dispatchStart, dispatchDone])

  return <Button {...{disabled, onClick}}>Send it to someone!</Button>
}

function CopyButton() {
  const disabled = useSelector(selectShareDisabled)
  const url = useSelector(selectGameUrl)
  const dispatchDone = useDelayedDispatch(mergeRight(
    objOf('type', SHARE_WORD_DONE),
    objOf('shareStatus', 'Copied to clipboard!'),
  ))
  const hideStatus = useSimpleDispatch(SHARE_STATUS_HIDE)

  const onCopy = useCallback(() => {
    dispatchDone()
    window.setTimeout(hideStatus, 1500)
  }, [dispatchDone, hideStatus])

  return (
    <CopyToClipboard text={url} onCopy={onCopy}>
      <Button {...{disabled}}>Share the link!</Button>
    </CopyToClipboard>
  )
}